<!-- eslint-disable prettier/prettier -->
<!--
 * @Author: Ashley.Liu
 * @Date: 2022-08-08 20:14:33
 * @LastEditTime: 2023-02-07 14:21:00
 * @Description: desc
-->
<template>
  <div class="search-help-content">
    <!-- title -->
    <div
      class="search-help-content__title flex-row flex-ai-center flex-jc-between"
    >
      <div class="title">Help</div>
      <div class="toolbar flex-row flex-ai-center">
        <zm-icon
          v-if="!isPined"
          name="pin"
          class="custom-icon-component mgr-sm"
          ariaLabel="pin help"
          @click="pinHelp"
        ></zm-icon>
        <zm-button
          icon="zm-icon-close"
          ghost
          @click="$emit('close')"
        ></zm-button>
      </div>
    </div>
    <!-- main -->
    <div class="search-help-content__main">
      <mavon-editor
        v-model="savedMarkedContent"
        style="height: 100%; width: 100%; border: none"
        placeholder="Loading..."
        :boxShadow="false"
        :subfield="false"
        defaultOpen="preview"
        :toolbarsFlag="false"
        :editable="false"
      ></mavon-editor>
    </div>
    <!-- footer -->
    <div
      class="
        search-help-content__footer
        flex-row flex-ai-center flex-jc-between
      "
    >
      <zm-dropdown @command="handleCommand">
        <router-link
          to=""
          class="flex-row flex-ai-center"
          v-if="versionList.length"
        >
          <span>{{ currentVersionDisplay }}</span
          ><i class="zm-icon-down"></i>
        </router-link>
        <zm-dropdown-menu v-if="versionList.length">
          <zm-dropdown-item
            v-for="(versionInfo, index) in versionList"
            :key="versionInfo.version"
            :command="
              versionInfo.version + '/index/' + (versionList.length - index)
            "
          >
            {{ `version_${versionList.length - index}` }}({{
              versionInfo.createdBy && versionInfo.createdBy.split('@')[0]
            }})</zm-dropdown-item
          >
        </zm-dropdown-menu>
      </zm-dropdown>
      <div class="flex-row flex-ai-center flex-jc-end">
        <zm-button
          type="text"
          @click="editMarkdown"
          :loading="editLoading"
          :disabled="+currentIndex !== versionList.length"
        >
          Edit
        </zm-button>
        <zm-button type="text" @click="deleteVersion" :disabled="!currentIndex">
          Delete
        </zm-button>
      </div>
    </div>
    <zm-dialog
      :visible.sync="markdownEditor"
      append-to-body
      title="Help Edit"
      show-close
      custom-class="help-markdown-editor"
    >
      <div slot="title" class="flex-row flex-ai-center">
        <div class="mgl-sm">
          Edit Help
          <!-- <span class="mgl-sm" style="color: #6e7680">{{
            '[ ' + $route.name + ' ]'
          }}</span> -->
        </div>
      </div>

      <mavon-editor
        v-model="markedContent"
        style="min-height: 512px; border: 1px solid #dfe3e8; border-radius: 8px"
        @save="saveHelp"
      ></mavon-editor>
      <div slot="footer">
        <zm-button @click="markdownEditor = false">Cancel</zm-button>
        <zm-button type="primary" @click="saveHelp" :loading="saveLoading">
          Save
        </zm-button>
      </div>
    </zm-dialog>
  </div>
</template>

<script>
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import {
  saveHelp,
  // canEditHelp,
  getAllVersion,
  getHelperMarkdsByUriVersion,
  getHelperLatestMarkdsByUri,
  deleteVersion
  // releaseLock
} from '@/api/pageHelp'
export default {
  components: {
    'mavon-editor': mavonEditor.mavonEditor
  },
  props: {
    isPined: Boolean
  },
  data() {
    return {
      markdownEditor: false,
      markedContent: '',
      savedMarkedContent: '',
      currentVersion: '',
      versionList: [],
      pined: false,
      saveLoading: false,
      editLoading: false,
      errorMsg:
        'The help module name is not configured, please contact the administrator!',
      currentIndex: null,
      creator: ''
    }
  },
  computed: {
    currentVersionDisplay() {
      return 'version_' + this.currentIndex + `(${this.creator})`
    }
  },
  watch: {
    '$route.path'(v, ov) {
      if (v !== ov) {
        this.$emit('close')
        this.getModuleId()
        this.getHelperMarkdsByUri()
      }
    }
  },
  created() {
    this.getModuleId()
    this.getHelperMarkdsByUri()
  },
  // beforeDestroy() {
  //   if (this.markdownEditor) this.releaseLock()
  // },
  methods: {
    async getHelperMarkdsByUri() {
      const { success, msg, content } = await getHelperLatestMarkdsByUri(
        this.helpModuleId
      )

      this.savedMarkedContent = success ? content : msg
    },
    async getModuleId() {
      const routeComponentObj = this.$router.matcher
        .getRoutes()
        .find(
          route =>
            route.name === this.$route.name && route.path === this.$route.path
        )?.components?.default
      this.helpModuleId =
        routeComponentObj.helpModuleId || routeComponentObj.name

      this.getAllVersion()
    },
    async getAllVersion() {
      const data = await getAllVersion(this.helpModuleId)
      this.versionList = data
      this.currentVersion = data?.[0]?.version
      this.creator = data?.[0]?.createdBy?.split('@')?.[0]
      this.currentIndex = data.length
    },
    async editMarkdown() {
      if (!this.helpModuleId) {
        this.$message.error(this.errorMsg)
        return
      }
      this.markdownEditor = true
      this.markedContent = this.savedMarkedContent
      // this.editLoading = true
      // try {
      //   const { getLocked, lockID } = await canEditHelp(
      //     this.helpModuleId,
      //     this.currentVersion
      //   )
      //   if (!getLocked) {
      //     this.$message.error(
      //       'The current document is locked and cannot be edited temporarily!'
      //     )
      //     return
      //   }
      //   this.lockID = lockID
      //   this.markdownEditor = true
      //   this.markedContent = this.savedMarkedContent
      // } finally {
      //   this.editLoading = false
      // }
      // this.editLoading = false
    },
    // releaseLock() {
    //   releaseLock(this.helpModuleId)
    // },
    async saveHelp() {
      if (!this.helpModuleId) {
        this.$message.error(this.errorMsg)
        return
      }
      this.saveLoading = true
      try {
        const resp = await saveHelp({
          uri: this.helpModuleId,
          version: this.currentVersion || undefined,
          content: this.markedContent,
          route: this.$route.path
          // lockID: this.lockID
        })
        if (resp) {
          this.markdownEditor = false
          this.getHelperMarkdsByUri()
          this.getAllVersion()
        }
      } finally {
        this.saveLoading = false
      }
    },
    handleCommand(version) {
      this.currentVersion = version.split('/index/')?.[0]
      this.currentIndex = version.split('/index/')?.[1]
      const creator =
        this.versionList[this.versionList.length - this.currentIndex]?.createdBy
      this.creator = creator?.split('@')?.[0]
      this.getHelperMarkdsByUriVersion()
    },
    async getHelperMarkdsByUriVersion() {
      const { success, msg, content } = await getHelperMarkdsByUriVersion({
        uri: this.helpModuleId,
        version: this.currentVersion
      })
      this.savedMarkedContent = success ? content : msg
    },
    pinHelp() {
      this.pined = !this.pined
      this.$emit('pin')
    },
    deleteVersion() {
      this.$confirm(
        'Confirm to delete ' + this.currentVersionDisplay + '?',
        'Warning',
        {
          type: 'warning'
        }
      ).then(async () => {
        const lastedVersion = await deleteVersion(
          this.helpModuleId,
          this.currentVersion
        )
        this.$message.success('Delete Success!')
        this.currentVersion = lastedVersion?.version
        this.savedMarkedContent = lastedVersion?.content
        this.getAllVersion()
        this.getHelperMarkdsByUri()
      })
    }
  }
}
</script>

<style lang="scss">
.search-help-content {
  width: 100%;
  border-left: 1px solid #dfe3e8;
  box-shadow: none !important; // drawer title dom has style
  &__title {
    height: 96px;
    font-size: 16px;
    border-bottom: 1px solid #dfe3e8;
    padding: 0 32px;
    line-height: 32px;
    .title {
      font-weight: 700;
      font-size: 24px;
      line-height: 32px;
    }
    .toolbar {
      // margin-left: 32px;
    }
    .custom-icon-component {
      width: 16px;
      height: 16px;
    }
  }
  &__main {
    height: calc(100vh - 50px - 96px - 56px);
    border-bottom: 1px solid #dfe3e8;
  }
  &__footer {
    font-size: 16px;
    padding: 0 32px;
    height: 56px;
  }
}
.help-markdown-editor {
  .v-note-wrapper {
    z-index: 100;
  }
}
</style>
